import { Typography, Box } from "@mui/material";
import { ReactNode } from "react";

interface ProgramReviewCardProps {
  programName: string;
  programColor?: string;
  children: ReactNode;
}

export const ProgramReviewCard = ({
  programName,
  programColor,
  children,
}: ProgramReviewCardProps) => {
  const bgColor = programColor || "#d3d3d3";
  const borderColor = programColor || "#d3d3d3";

  return (
    <Box
      data-cypress="program-review-card"
      data-program-name={programName}
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        border: `2px solid ${bgColor}`,
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: bgColor,
          borderBottom: `3px solid ${borderColor}`,
          px: { xs: 2, sm: 3 },
          py: { xs: 1.5, sm: 2 },
          pr: { xs: 10, sm: 11 }, // Extra right padding to prevent overlap with points badges
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: "text.primary",
            fontSize: { xs: "0.9rem", sm: "1rem" },
          }}
        >
          {programName || "Program"}
        </Typography>
      </Box>
      <Box
        className="reward-options"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          p: { xs: 1.5, sm: 2 },
          gap: { xs: 1.5, sm: 2 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
